document.addEventListener("DOMContentLoaded", function () {
    const domain = window.location.hostname;
    const searchParams = new URLSearchParams(window.location.search);
    const isGerman = domain.includes("glamorise.de") || window.location.pathname.includes("/de") || window.location.pathname.includes("/de-de") || searchParams.get("locale") === "de" || searchParams.get("locale") === "en-DE";

    if (isGerman) {
        function translateText(text) {
            if (!text || typeof text !== "string") return text;

            const translations = {
                "SIGN IN": "ANMELDEN",
                "Sign In": "Anmelden",
                "Create an Account": "Konto erstellen",
                "BAG": "EINKAUFSTASCHE",
                "Working Out": "Workout",
                "Key features": "Haupteigenschaften",
                "Details": "DETAILS",
                "Materials & Care": "Materialien & Pflegehinweise",
                "Camisole": "Camisole",
                "A mesh insert and high neckline": "Mesh-Einsatz und hohes Dekolleté",
                "Reinforced Cups": "Verstärkte Körbchen",
                "Level up the support, no wire needed": "Für maximalen Support, auch ohne Bügel",
                "Wide Straps": "Breite Träger",
                "Add to Bag": "Zur Einkaufstasche hinzufügen",
                "Behind the Bra": "Hinter den BH-Kulissen",
                "Crisscrossed Design": "Überkreuz-Design",
                "For secure support": "Für sichere Unterstützung",
                "Inner-Bust Band": "Innenbrustband",
                "The Reviews Say it Best": "Die Rezensionen sprechen für sich",
                "Lifts without a wire": "Hebt ohne Bügel",
                "Seamless Cups": "Nahtlose Körbchen",
                "For a smooth fit": "Für eine nahtlose Passform",
                "Non-Stretch Lace Straps": "Nicht elastische Träger mit Spitze",
                "Adjust in the back": "Im Rücken verstellen",
                "I need a sports bra that can keep up with me.": "Ich brauche einen Sport-BH, der mit mir mithalten kann.",
                "I want something so comfortable I forget about it.": "Ich möchte einen BH, der so bequem ist, dass ich ihn nicht merke.",
                "Give me something flirty and fun that still holds me in.": "Maximaler Support und gleichzeitig sexy und verspielt.",
                "I need a supportive bra for everywhere but the gym.": "Ich brauche einen stützenden BH für den Alltag, nicht für den Sport.",
                "I like options — sports bras, everyday bras and lingerie.": "Ich mag Sport-BHs, Alltags-BHs und Lingerie.",
                "What Size Is The Bra You Wear Most and Feel Your Best In?": "Welche Größe hat der BH, den Sie am häufigsten tragen und sich am besten fühlen?",
                "The only bras I'll ever wear have underwires.": "Die einzigen BHs, die ich jemals tragen werde, sind Bügel-BHs.",
                "I like to wear both depending on my mood.": "Ich trage beide BHs gerne, je nach Stimmung.",
                "I've never worn a underwire I like and don't plan to start now.": "Ich habe noch keinen BH-Bügel getragen, der mir gefällt, und das soll auch so bleiben.",
                "Next Frage": "Nächste Seite",
                "Which Type of Closure Feels The Most Secure to You?": "Welcher Verschluss gibt Ihnen am meisten Sicherheit?",
                "I like them to fit seamlessly under any top, even tanks.": "Ich möchte, dass sich mein BH unter Tops, auch Tank-Tops, nicht abzeichnet.",
                "I want the extra security of wider, padded straps.": "Ich möchte einen BH mit breiten, gepolsterten Träger für maximale Sicherheit.",
                "As long as they're comfortable, I'll take any width.": "Solange sie bequem sind, nehme ich jede Breite.",
                "Which Features Matter Most to You in a Bra? Pick Your Top Two.": "Welche Eigenschaften sind Ihnen bei einem BH besonders wichtig? Wählen Sie die zwei, die Ihnen am wichtigsten sind.",
                "My bust and back appreciate it any chance they get.": "Meine Brust und mein Rücken lieben den Komfort.",
                "I should feel confidently held up and in all day.": "Ich möchte einen BH, der mir den ganzen Tag ein sicheres Gefühl gibt.",
                "I want to forget I'm wearing a bra the minute I put it on.": "Ich möchte nicht spüren, dass ich überhaupt einen BH trage.",
                "Neutral has never been my first choice.": "Neutral war noch nie meine erste Wahl.",
                "Oh, no! We don't have your size right now, but we're always adding more to our collection. Sign up below to be the first to know when your size becomes available.": "Oh nein! Leider ist Ihre Größe noch nicht im Sortiment, aber wir fügen immer wieder neue hinzu.",
                "Enter Email Address": "E-Mail-Adresse eingeben",
                "Get Notified": "Benachrichtigung erhalten",
                "By entering your email you agree to our terms of use and to receive emails from Glamorise.": "Mit der Eingabe Ihrer E-Mail-Adresse erklären Sie sich mit unseren Nutzungsbedingungen einverstanden und stimmen dem Erhalt von E-Mails von Glamorise zu.",
                "The Bra Finder": "Der BH-Finder",
                "Which One Best Describes What You'll Be Doing in Your New Bra": "Was beschreibt am besten, was Sie in Ihrem neuen BH tun werden?",
                "Training": "Training",
                "Hanging Out": "Für zu Hause",
                "Going Out": "Zum Ausgehen",
                "Work & Play": "Work & Play",
                "All Of the Above": "Alle oben genannten",
                "Go Back": "Zurück",
                "Do You Prefer an Underwire Bra?": "Bevorzugen Sie Bügel-BHs?",
                "Always": "Immer",
                "Sometimes": "Manchmal",
                "Never": "Nie",
                "Front": "Front",
                "Back": "Zurück",
                "Either": "Beides",
                "How Do You Like Your Straps?": "Welche BHs gefallen Ihnen?",
                "Thin": "Dünn",
                "Padded": "Gepolstert",
                "Support": "Support",
                "Lift & Shape": "Anheben & formen",
                "Comfort": "Komfort",
                "Color & Style": "Farbe & Stil",
                "More Sizes Are in the Works": "Weitere Größen sind geplant",
                "Your Bag": "Ihre Einkaufstasche",
                "Order Total": "Bestellung gesamt",
                "Checkout": "Zur Kasse",
                "Keep Shopping": "Weiter einkaufen",
                "Search Suggestions": "Suchvorschläge",
                "Collection Suggestions": "Kollektionsempfehlungen",
                "Page Suggestions": "Empfohlene Seiten",
                "Search instead for": "Stattdessen suchen nach",
                "What are you looking for?": "Was suchen Sie?",
                "Change Model": "Modell ändern",
                "Country / Region": "Land / Region",
                "Currency": "Währung",
                "Language": "Sprache",
                "Submit": "Senden",
                "Cancel": "Abbrechen",
                "Log in": "Einloggen",
                "Enter your email and we'll send you a login code": "Nach Angabe der E-Mail-Adresse erhalten Sie einen Login-Code",
                "Email": "E-Mail",
                "Continue": "Fortfahren",
                "Privacy": "Datenschutz",
                "Orders": "Bestellungen",
                "Profile": "Profil",
                "Settings": "Einstellungen",
                "Log out": "Ausloggen",
                "Refund policy": "Retourenpolitik",
                "Privacy policy": "Datenschutzbestimmungen",
                "Terms of service": "Nutzungsbedingungen",
                "Reviews": "Rezensionen",
                "Style": "STIL",
                "Color": "FARBE",
                "Featured": "Empfohlen",
                "All Plus Größe Bras": "Alle Plus-Size-BHs",
                "Bestsellers": "Bestseller",
                "Sports Bras": "Sport-BHs",
                "Underwire Bras": "Bügel-BHs",
                "Bralettes": "Bralettes",
                "Wide Strap Bras": "BHs mit breiten Trägern",
                "T-Shirt Bras": "T-Shirt-BHs",
                "Full-Coverage Bras": "Full-Coverage-BHs",
                "Accessoires": "Accessoires",
                "On Sale": "Sale",
                "Band Größe": "Unterbrustbandgröße",
                "Cup Größe": "Körbchengröße",
                "Enter your email": "E-Mail-Adresse angeben",
                "My Account": "Mein Konto",
                "Cups": "Körbchen",
                "Bands": "Unterbrustbänder",
                "New": "Neu"
            };

            // Word boundary translations
            const wordBoundaryTranslations = {
                "\\bSort\\b": "Sortieren"
            };

            // First apply exact phrase translations
            let translatedText = text;
            Object.entries(translations).forEach(([eng, ger]) => {
                translatedText = translatedText.replace(new RegExp(eng.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'g'), ger);
            });

            // Then apply word boundary translations
            Object.entries(wordBoundaryTranslations).forEach(([eng, ger]) => {
                translatedText = translatedText.replace(new RegExp(eng, 'g'), ger);
            });

            return translatedText;
        }

        function translateTextNodes(element) {
            if (!element || !element.childNodes) return;
            
            // If this element or one of its ancestors has the "screenreader" class, skip it.
            if (element.nodeType === 1 && element.closest('.screenreader')) {
                return;
            }

            element.childNodes.forEach(node => {
                if (node.nodeType === 3 && node.nodeValue.trim()) {
                    const newText = translateText(node.nodeValue.trim());
                    if (newText !== node.nodeValue.trim()) {
                        node.nodeValue = node.nodeValue.replace(node.nodeValue.trim(), newText);
                    }
                } else if (node.nodeType === 1) {
                    translateTextNodes(node);
                }
            });
        }

        function replaceTextInElements() {
            const specificSelectors = [
                '.box-option__title',
                '.box-option__copy',
                '.step-header__question',
                '.step-footer__btn',
                '.fit-finder-outro__description',
                '.fit-finder-outro__btn',
                '.fit-finder-outro__disclaimer',
                '.js-accordian-btn',
                '#btnAddToBagText'
            ];

            document.querySelectorAll([
                ...specificSelectors,
                'h1, h2, h3, h4, h5, h6, p, span, label, button, div'
            ].join(', ')).forEach(el => {
                translateTextNodes(el);
            });
        }

        function replaceAttributes() {
            document.querySelectorAll("[aria-label], [title], [alt], [placeholder]").forEach(el => {
                ["aria-label", "title", "alt", "placeholder"].forEach(attr => {
                    if (el.hasAttribute(attr)) {
                        el.setAttribute(attr, translateText(el.getAttribute(attr)));
                    }
                });
            });
        }

        // Initial translation
        replaceTextInElements();
        replaceAttributes();

        // MutationObserver setup
        const observer = new MutationObserver(mutations => {
            mutations.forEach(mutation => {
                if (mutation.type === 'childList') {
                    mutation.addedNodes.forEach(node => {
                        if (node.nodeType === 1) {
                            translateTextNodes(node);
                            if (node.querySelectorAll) {
                                node.querySelectorAll('[aria-label], [title], [alt], [placeholder]').forEach(el => {
                                    ["aria-label", "title", "alt", "placeholder"].forEach(attr => {
                                        if (el.hasAttribute(attr)) {
                                            el.setAttribute(attr, translateText(el.getAttribute(attr)));
                                        }
                                    });
                                });
                            }
                        }
                    });
                }
            });
        });

          const button = document.getElementById("GrößentabelleModalTrigger");
    if (button) {
        button.id = "sizeChartModalTrigger";
    }

        observer.observe(document.body, {
            childList: true,
            subtree: true,
            characterData: true
        }); 

        // Backup check every 2 seconds
        setInterval(() => {
            replaceTextInElements();
            replaceAttributes();
        }, 2000);
    }
});